import { FormFieldCommentForEditor, FormFieldSubtitle } from '@publishing-engine/domain/types/article';
import { useFormContext } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { FieldLabel } from 'src/components/Field';
import RichTextSubmission from 'src/components/Submission/GenericFieldComponents/RichText/RichTextSubmission';

export default function GenericRichTextInput({
  config
}: {
  config: FormFieldSubtitle | FormFieldCommentForEditor;
}) {
  const form = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const value = form.watch(field);

  return (
    <Flex flexDirection="column" gap={4}>
      <FieldLabel
        isRequired={validations.required}
        label={labels.main}
        subText={labels.subtitle}
        helpText={labels.helpText}
      />

      <RichTextSubmission
        initialValue={value ?? ''}
        label={labels.main}
        field={field}
        maxWords={validations?.maxWords}
      />
    </Flex>
  );
}
